import { Component } from '@angular/core';
import {HttpClient } from '@angular/common/http'; 
import { AuthService } from '../../_services'; 

@Component({
  selector: 'Part',
  templateUrl: './part.component.html',  
})

 export class PartComponent {
 public prjId:any
 public userId:any
  constructor(private HttpClient : HttpClient,private auth : AuthService) { 
  }  
  ngOnInit(){ 
  }

}
 


// WEBPACK FOOTER //
// ./src/app/maintenance/part/part.component.ts